import { FRAMEWORKS } from "../enums/enums";

export const matchFramework = (nameToMatch: string) => {
    return FRAMEWORKS.find(item => nameToMatch.toLowerCase().includes(item.name.toLowerCase()) || item.name.toLowerCase().includes(nameToMatch.toLowerCase())) || FRAMEWORKS[FRAMEWORKS.length - 1]
}
